import { Img } from "container/Manual/components/content/Image";
import { PageLink } from "container/Manual/components/content/PageLink";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const DATEFORMAT = () => {
  return (
    <CardSection id="DATEFORMAT" title="DATEFORMAT">
      <Paragraph>
        날짜/시간 데이터 타입으로 저장된 값을 지정된 형식의 텍스트 문자열로
        변환합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>DATEFORMAT(DATETIME, FORMAT)</Paragraph>
        <Ul>
          <Li>
            <b>DATETIME</b>은 변환하려는 날짜입니다.
          </Li>
          <Li>
            <b>FORMAT</b>은 <b>DATETIME</b>을 변환하려는 형식입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>
          DATEFORMAT(`Date-Received`, "dd-MMMM-yyyy HH:mm")
        </Paragraph>
        <Img src="computeDateFormat" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          <b>FORMAT</b>에 사용할 구문에 대한 자세한 내용은{" "}
          <PageLink
            label="Date and Time Syntax"
            url="/#/manual?key=project.computedColsTool"
          />{" "}
          문서를 참조하세요.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
